import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { ECacheKeys } from 'cache/CacheKeys';
import type { IUserAccount } from 'api/resources/user';
import { getUserAccount } from 'api/resources/user';

export const useGetUserAccount = (
	userName: string,
	options?: UseQueryOptions<IUserAccount[]>
) => {
	const query = useQuery<IUserAccount[]>({
		queryKey: [ECacheKeys.UserData, userName],
		refetchInterval: false,
		refetchOnWindowFocus: false,
		queryFn: () => getUserAccount(userName),
		...(options || {}),
	});

	return query;
};
